<template>
    <div>
        <div style="padding:3px;padding-top:7px; margin-top:-10px;margin-bottom:5px" class=" row page-header-style">
            <!--<div style="padding-bottom:5px; padding-top:2px; margin:0px">-->
            <div class="col-sm-6  col-xs-6">
                <div class="pull-left">
                    <ul class="nav nav-pills">
                        <li :class="{ 'active': $route.name === 'fmd.bags' }">
                            <router-link exact-active-class="active" :to="{ path: '/fmd/bags'}">
                                <i class="fa fa-list"></i>  Workslate
                            </router-link>
                        </li>
                        <li :class="{ 'active': $route.name === 'fmd.delivered' }">
                            <router-link exact-active-class="active" :to="{ path: '/fmd/delivered'}">
                                <i class="fa fa-history"></i>  History
                            </router-link>
                        </li>
                        <!--<li :class="{ 'active': $route.name === 'fmd.newbag' }">
                            <router-link exact-active-class="active" :to="{ path: '/fmd/bag'}">
                                <i class="fa fa-shopping-bag"></i>  New Bag
                            </router-link>
                        </li>-->
                        <li :class="{ 'active': $route.name === 'fmd.patients' }">
                            <router-link exact-active-class="active" :to="{ path: '/fmd/patients'}">
                                <i class="fa fa-users"></i>  Patients
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-sm-2">
                <a class="btn btn-primary pull-right" @click="NavigateToNewBagWithoutPatient">
                    <i class="fa fa-plus" />&nbsp;New Bag
                </a>
            </div>
            <div class="col-sm-4">

                <div class="form-group">
                    <PatientSearchBox v-model="Patient" :clear-result="clearSearch"></PatientSearchBox>
                </div>
            </div>
            <!--</div>-->
            <a v-shortkey="{ keys:'alt+b', title:'FMD Header', description:'Navigate to Dashboard'}" @shortkey="NavigateToDashboard"></a>
            <a v-shortkey="{ keys:'alt+w', title:'FMD Header', description:'Navigate to Workslate'}" @shortkey="NavigateToBags"></a>
            <a v-shortkey="{ keys:'alt+p', title:'FMD Header', description:'Navigate to Patients'}" @shortkey="NavigateToPatients"></a>
            <a v-shortkey="{ keys:'alt+n', title:'FMD Header', description:'Create New Bag'}" @shortkey="NavigateToNewBagWithoutPatient"></a>
            <!--<a v-shortkey="['alt+b']" @shortkey="NavigateToDashboard"></a>
            <a v-shortkey="['alt+w']" @shortkey="NavigateToBags"></a>
            <a v-shortkey="['alt+p']" @shortkey="NavigateToPatients"></a>
            <a v-shortkey="['alt+n']" @shortkey="NavigateToNewBag"></a>-->
        </div>
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    //import FmdHub from '../FmdSignalrHub/FmdHub'
    import PatientSearchBox from "../../appcontrols/PatientSearchBox/PatientSearchBox.scp.html"


    export default {

        props: [],
        data: function () {
            return {
                FmdHub: {},
                Patient: null,
                clearSearch: 0
            }
        },
        watch: {
            Patient: function (pt) {
                var id = pt.id;

                this.$router.push({
                    path: '/fmd/patient/' + id
                })

                this.$nextTick(() => { this.clearSearch += 1; })
            }
        },
        mounted() {
            //var hub = new FmdHub("C86AECD1-C060-4869-B215-765ECC836C13");


            //hub.OnBagUpdated((bagId) => {
            //    console.log('FMD.BagUpdated', { bagId})
            //    this.$bus.$emit('FMD.BagUpdated', { bagId})
            //});

            //hub.OnBagAdded((bagId) => {
            //    console.log('FMD.BagAdded', { bagId})
            //    this.$bus.$emit('FMD.BagAdded', { bagId})
            //});

            //hub.OnBagItemUpdated((bagId, bagItemId) => {
            //    console.log('FMD.BagItemUpdated', { bagId, bagItemId })
            //    this.$bus.$emit('FMD.BagItemUpdated', { bagId, bagItemId })
            //});

            //hub.OnBagItemAdded((bagId, bagItemId) => {
            //    console.log('FMD.BagItemAdded', { bagId, bagItemId })
            //    this.$bus.$emit('FMD.BagItemAdded', { bagId, bagItemId })
            //});

            //this.FmdHub = hub;
        }
        , methods: {
            NavigateToDashboard() { this.$router.push({ path: '/fmd/dashboard' }) },
            NavigateToBags() { this.$router.push({ path: '/fmd/bags' }) },
            NavigateToPatients() { this.$router.push({ path: '/fmd/patients' }) },
            NavigateToNewBag() { this.$router.push({ path: '/fmd/newbag' }) },
            NavigateToNewBagWithoutPatient() {
                var d = new Date();
                var n = d.getTime();
                this.$router.push({ name: 'fmd.managebag', params: { key: n } })
            }
            // NavigateToNewBagWithoutPatient() { this.$router.push({ path: '/fmd/bag/' }) }


        },
        components: {

            PatientSearchBox
        }
    }
</script>


// WEBPACK FOOTER //
// FmdHeader.scp.html?2b6bba04